import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { BaselineCheckTreeActions } from './baseline-check-tree.actions';
import { BaselineTreeCheckTreeService } from '../../service/baselinecheck-tree.service';
import { convertRiskMapProcessIntoBaselineCheckTree } from './baseline-check-tree.reducer';
import { RiskMapProcess } from '../../../../graphql/generated';
import { RiskMapTreeService } from '../../service/riskmaptree.service';
import { EvaluationTreeService } from '../../service/evaluationTree.service';
import { MessageService } from 'primeng/api';
import { graphQlErrorMessage } from '../../shared/graphql-error.util';
import { flatMutationEntries } from '../../shared/graphql-mutation-response.util';


@Injectable()
export class BaselineCheckTreeEffects {

  loadBaselineCheckTrees$ = createEffect(
    (rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService)) => {
      return this.actions$.pipe(

        ofType(BaselineCheckTreeActions.loadBaselineCheckTree),
        mergeMap(({ campaignId, legalEntityId, parameters, fields, au, ics, completed }) =>
          rs.getBaselineCheckTree(campaignId, legalEntityId, parameters, au, ics, completed).pipe(
            map((baseline) => {
              console.log('baselineCheck:', baseline);

              return BaselineCheckTreeActions.loadBaselineCheckTreeSuccess({
                baselineCheck: convertRiskMapProcessIntoBaselineCheckTree(baseline?.data?.[0]?.processParameters as RiskMapProcess[]),
                pageParameters: baseline,
                fields
              });
            }),
            catchError((error) => of(BaselineCheckTreeActions.loadBaselineCheckTreeFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllEvaluationTree$ = createEffect(
    (rs: EvaluationTreeService = inject(EvaluationTreeService)) => {
      return this.actions$.pipe(
        ofType(BaselineCheckTreeActions.loadAllBaselineCheckTree),
        mergeMap(({ campaignId, legalEntityId, parameters, fields, au, completed }) =>
          rs.getAllEvaluationTree(campaignId, legalEntityId).pipe(
            mergeMap((baselineCheck) => {

              const successAction = BaselineCheckTreeActions.loadAllBaselineCheckTreeSuccess({
                baselineCheck,
                fields
              });

              // const anotherAction = BaselineCheckTreeActions.loadEvaluationTree({
              //   au,
              //   campaignId,
              //   legalEntityId,
              //   parameters: param,
              //   fields,
              //   completed
              // });

              return [successAction];
            }),
            catchError((error) =>
              of(BaselineCheckTreeActions.loadAllBaselineCheckTreeFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  // updateBaseline$ = createEffect(
  //   (rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService)) => {
  //     return this.actions$.pipe(

  //       ofType(BaselineCheckTreeActions.updateBaselineTree),
  //       mergeMap(({ cptIds, icsRationale, irRationale, riskMapId, parameterName, filter }) =>
  //         rs.updateBaelineTree(riskMapId, irRationale, icsRationale, filter).pipe(
  //           map((baseline) => {
  //             return BaselineCheckTreeActions.updateBaselineTreeSuccess({
  //               baseline: convertRiskMapProcessIntoBaselineCheckTree(baseline?.processParameters as RiskMapProcess[]),
  //               cptIds,
  //               parameterName,
  //             });
  //           }),
  //           catchError((error) => of(BaselineCheckTreeActions.updateBaselineTreeFailure({ error, cptIds, parameterName })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  updateBaseline$ = createEffect(
    (
      rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService),
      messageService: MessageService = inject(MessageService)
    ) => {
      return this.actions$.pipe(
        ofType(BaselineCheckTreeActions.updateBaselineTree),
        mergeMap(({ cptIds, icsRationale, irRationale, riskMapId, parameterName, filter, au, campaignId, completed, ics, legalEntityId, parameters, fields }) =>
          rs.updateBaelineTree(riskMapId, irRationale, icsRationale, filter).pipe(
            mergeMap((baseline) => {
              const convertedBaseline = convertRiskMapProcessIntoBaselineCheckTree(flatMutationEntries(baseline, entry => entry.processParameters) as RiskMapProcess[]);
              return [
                BaselineCheckTreeActions.updateBaselineTreeSuccess({
                  baseline: convertedBaseline,
                  cptIds,
                  parameterName
                }),
                BaselineCheckTreeActions.loadAllBaselineCheckTree({
                  au,
                  campaignId,
                  completed,
                  ics,
                  legalEntityId,
                  parameters,
                  fields
                })
              ];
            }),
            catchError((error) => {
              messageService.add({
                severity: 'error',
                summary: 'Update Baseline Check Error',
                detail: graphQlErrorMessage(error, 'Unable to update the baseline check'),
                life: 10000
              });
              return of(
                BaselineCheckTreeActions.updateBaselineTreeFailure({ error, cptIds, parameterName }),
                BaselineCheckTreeActions.loadBaselineCheckTree({
                  au,
                  campaignId,
                  completed,
                  ics,
                  legalEntityId,
                  parameters,
                  fields
                })
              );
            })
          )
        )
      );
    },
    { functional: true }
  );


  // updateTreeNote$ = createEffect(
  //   (rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService)) => {
  //     return this.actions$.pipe(

  //       ofType(BaselineCheckTreeActions.updateTreeNote),
  //       mergeMap(({ campaignId, legalEntityId, processCode, cptIds, parameterName, note }) =>
  //         rs.updateTreeNote(campaignId, legalEntityId, processCode, note).pipe(
  //           map((riskMap) => {
  //             return BaselineCheckTreeActions.updateTreeNoteSuccess({
  //               riskMap: riskMap,
  //               cptIds,
  //               parameterName,
  //               note
  //             });
  //           }),
  //           catchError((error) => of(BaselineCheckTreeActions.updateTreeNoteFailure({ error, cptIds, parameterName })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );


  updateTreeNote$ = createEffect(
    (
      rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService),
      messageService: MessageService = inject(MessageService)
    ) => {
      return this.actions$.pipe(
        ofType(BaselineCheckTreeActions.updateTreeNote),
        mergeMap(({ campaignId, legalEntityId, processCode, cptIds, parameterName, note, au, completed, ics, parameters, fields, filter }) =>
          rs.updateTreeNote(campaignId, legalEntityId, processCode, note, filter).pipe(
            mergeMap((riskMap) => [
              BaselineCheckTreeActions.updateTreeNoteSuccess({
                riskMap,
                cptIds,
                parameterName,
                note
              }),
              // 👉 Altra azione desiderata dopo il successo
              BaselineCheckTreeActions.loadAllBaselineCheckTree({
                au,
                campaignId,
                legalEntityId,
                completed,
                ics,
                parameters,
                fields
              })
              // Esempio aggiuntivo: ricarica albero
              // BaselineCheckTreeActions.reloadTree({ campaignId, legalEntityId })
            ]),
            catchError((error) => {
              messageService.add({
                severity: 'error',
                summary: 'Update Note Error',
                detail: graphQlErrorMessage(error, 'Unable to update the note'),
                life: 10000
              });
              return of(
                BaselineCheckTreeActions.updateTreeNoteFailure({
                  error,
                  cptIds,
                  parameterName
                })
              );
            })
          )
        )
      );
    },
    { functional: true }
  );


  exportRiskmap$ = createEffect(
    (rs: BaselineTreeCheckTreeService = inject(BaselineTreeCheckTreeService)) => {
      return this.actions$.pipe(

        ofType(BaselineCheckTreeActions.exportBaselineCheckTree),
        mergeMap(({ campaignId, legalEntityId, parameters, timeZone }) =>
          rs.exportBaselineCheckTree(campaignId, legalEntityId, timeZone, parameters
          ).pipe(
            map((riskMap) => {
              this.downloadFile(riskMap!.data![0]!.content, riskMap!.data![0]!.filename)
              return BaselineCheckTreeActions.exportBaselineCheckTreeSuccess({
                riskMap
              });
            }),
            catchError((error) => of(BaselineCheckTreeActions.exportBaselineCheckTreeFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  async downloadFile(response: string, fileName: string | undefined) {
    const typeFormat = {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
    const link = window.document.createElement("a");
    const blob = this.base64ToBlob(response, typeFormat.type); // Cambia il tipo MIME
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName ?? "fileExport";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }

  constructor(private actions$: Actions) { }
}
